import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Grid, Drawer, Divider, Button } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DashboardWrapper from "../containers/DashboardWrapper";
import {
  setCurrentPage,
  getReportTotalStatsData,
  getReportData,
  setFilter,
  getDownloadReportData,
  getDownloadReportDataNtt,
  setCurrentPageNumber,
  getSavedSelectedReportTagDataBy,
  getReportDataNtt,
  setDownloadReportData,
  setDownloadReportDataNtt,
  getReportDataHokuden,
  getDownloadReportDataHokuden,
} from "../actions";
import Period from "../components/Filter/Period";
import FilterApplied from "../components/Filter/FilterApplied";
import Calendar from "../components/Calendar/Calendar";
import ReportTable from "../components/Table/ReportTable";
import TagConfig from "../config/TagConfig";
import { CSVLink } from "react-csv";
import moment from "moment";
import "moment-timezone";
import LocalStorageHelper from "../utils/helper/localstorage_helper";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  contentGrid: {
    marginTop: theme.spacing(1),
    width: "100%%",
  },
  contentGridSlim: {
    marginTop: theme.spacing(1),
    width: "90%",
  },
  root: {
    marginTop: 32,
    minWidth: 275,
  },
  title: {
    fontSize: 14,
  },
  date: {
    marginBottom: 12,
  },
  filtered: {
    marginTop: 10,
    marginLeft: 16,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    top: 62,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  },
  tagTextWrapper: {
    padding: "16px",
  },
  tagTip: {
    fontWeight: "bold",
    marginBottom: 16,
  },
  tagText: {
    fontSize: "14px",
    marginBottom: 16,
  },
}));

const Report = ({
  setCurrentPage,
  setCurrentPageNumber,
  getReportTotalStatsData,
  getReportData,
  setFilter,
  currentPageNumber,
  periodType,
  filterStore,
  seasonData,
  selectedSeasonLabel,
  getDownloadReportData,
  getDownloadReportDataNtt,
  downloadData,
  filteredTotal,
  getSavedSelectedReportTagDataBy,
  getReportDataNtt,
  getReportDataHokuden,
  setDownloadReportData,
  setDownloadReportDataNtt,
  getDownloadReportDataHokuden,
}) => {
  const isNtt = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9";
  const classes = useStyles();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [tagData, setTagData] = useState([]);
  const [reportTagResultData, setReportTagResultData] = useState(
    TagConfig.reportResultTagTemp2
  );
  const [downloadImage, setDownloadImage] = useState([]);
  const [isDownloaded, setIsDownloaded] = useState(false);
  const [currentJstTime, setCurrentJstTime] = useState("");
  const csvLinkRef = useRef(null);
  const companyName = LocalStorageHelper.getCompany();

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    setCurrentPageNumber(1);
    let copyFilter = { ...filterStore };
    copyFilter.tag = [];
    setFilter(copyFilter);
  }, []);

  useEffect(() => {
    if (seasonData.length > 0) {
      if (companyName === "tepco") {
        getReportData({ pageNumber: currentPageNumber });
      } else if (companyName === "ntt" || companyName === "ntt-ft") {
        getReportDataNtt({ pageNumber: currentPageNumber })
      } else if (companyName === "hokuden") {
        getReportDataHokuden({ pageNumber: currentPageNumber })
      }
    }
  }, [currentPageNumber, seasonData]);

  useEffect(() => {
    if (periodType === "season") {
      setTagData(TagConfig.seasonTag);
    } else {
      setTagData(TagConfig.missionTagB.concat(TagConfig.missionTagC));
    }
  }, [periodType]);

  useEffect(() => {
    if (downloadData.length > 0 && !isDownloaded) {
      csvLinkRef.current.link.click(); // CSVLink のクリックイベントを発火
      setIsDownloaded(true);
      setDownloadReportData([]);
      setDownloadReportDataNtt([]);
    }
  }, [downloadData, isDownloaded, currentJstTime]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleImageSelect = (event, value) => {
    const isChecked = event.target.checked;
    if (isChecked) {

      setDownloadImage((prev) => [...prev, value]);
    } else {
      // 解除時に配列から削除
      setDownloadImage((prev) => prev.filter((url) => url !== value));
    }
  };

  const handleReportDownload = () => {
    setIsDownloaded(false);
    if (companyName === "ntt" || companyName === "ntt-ft") {
      getDownloadReportDataNtt();
    } else if (companyName === "hokuden") {
      getDownloadReportDataHokuden();
    } else {
      getDownloadReportData();
    }
    setCurrentJstTime(moment().tz("Asia/Tokyo").format("YYYYMMDDHHmmss"));
  };

  return (
    <DashboardWrapper>
      <Grid container spacing={0} direction="row" justifyContent="center">
        <Grid item xs={12} lg={12}>
          <Grid
            container
            justifyContent={"center"}
            className={open ? classes.contentGridSlim : classes.contentGrid}
          >
            <Grid item xs={12} lg={10}>
              <Grid
                container
                direction="row"
                justifyContent={"space-between"}
                className={open ? classes.contentGridSlim : classes.contentGrid}
              >
                <Grid item>
                  <Period isReport={true} />
                </Grid>
                <Grid item>
                  <Calendar companyName={companyName} />
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              lg={10}
              className={classes.filtered}
            >
              <Grid
                container
                direction="row"
                justifyContent={"space-between"}
                alignItems="flex-end"
                className={open ? classes.contentGridSlim : classes.contentGrid}
              >
                <Grid item>
                  <FilterApplied companyName={companyName} />
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={handleReportDownload}
                    disabled={filteredTotal === 0 || filteredTotal === "--"}
                  >
                    報告一括ダウンロード(CSV)
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} lg={10} className={classes.filtered}>
              <ReportTable
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                handleImageSelect={handleImageSelect}
                downloadImage={downloadImage}
                setDownloadImage={setDownloadImage}
                open={open}
                companyName={companyName}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <div className={classes.tagTextWrapper}>
          {reportTagResultData.length > 0 && (
            <>
              <div className={classes.tagTip}>ツルツタ報告確認結果タグ</div>
              {reportTagResultData.length > 0 &&
                reportTagResultData.map((row, index) => (
                  <div className={classes.tagText} key={index}>
                    {row.level !== "-" ? row["value"] : null}
                  </div>
                ))}
            </>
          )}
        </div>
      </Drawer>
      <CSVLink
        data={downloadData}
        filename={`【ピクトレ】報告_${selectedSeasonLabel}_${currentJstTime}.csv`}
        className="hidden"
        ref={csvLinkRef}
      />
    </DashboardWrapper>
  );
};

Report.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  // currentPageNumber: state.report.currentPageNumber,
  currentPageNumber: state.home.currentPageNumber,
  periodType: state.app.periodType,
  filterStore: state.report.filter,
  filteredTotal: state.report.filteredTotal,
  seasonData: state.app.seasonData,
  selectedSeasonLabel: state.app.selectedSeasonLabel,
  downloadData: state.report.downloadData,
  allImageDataByFilename: state.image.allImageDataByFilename,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
  getReportTotalStatsData: () => dispatch(getReportTotalStatsData()),
  getReportData: (param) => dispatch(getReportData(param)),
  getDownloadReportData: (param) => dispatch(getDownloadReportData(param)),
  getDownloadReportDataNtt: (param) => dispatch(getDownloadReportDataNtt(param)),
  setFilter: (param) => dispatch(setFilter(param)),
  getSavedSelectedReportTagDataBy: (param) => dispatch(getSavedSelectedReportTagDataBy(param)),
  getReportDataNtt: (param) => dispatch(getReportDataNtt(param)),
  setDownloadReportData: (param) => dispatch(setDownloadReportData(param)),
  setDownloadReportDataNtt: (param) => dispatch(setDownloadReportDataNtt(param)),
  getReportDataHokuden: (param) => dispatch(getReportDataHokuden(param)),
  getDownloadReportDataHokuden: (param) => dispatch(getDownloadReportDataHokuden(param)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
